<template lang="pug">
  #signin-2fa.xs-12
    .title.text-center
      h1.xs-f-small.upper.xs-mt-100m.xs-mb-100m Enter verification code

    p.xs-f-xsmall.xs-mb-100m To login to your account, enter the code sent to {{ sentToEmail }}.

    form(name="verify_form" @submit.prevent="verifyCode" novalidate)
      .row
        .mr-input-wrap.xs-8.sm-6.xs-offset-2.sm-offset-3
          mrInput(v-model="oneTimePassword" :v="v$.oneTimePassword" label="One Time Password" v-mask="'######'" required="true" data-mr-ass="'one-time-password'")

      .row
        button.mr-btn.btn-block.font-xsmall.xs-mt-200m(type="submit" :disabled="disableSubmit" :class="{ disabled: disableSubmit }" data-mr-ass="send-email") Verify

    p.xs-f-small.max-at-tweak.text-center.xs-mt-100m Didn't receive a code?&nbsp;
      button(@click="resendCode").btn-link.xs-pl-50m.xs-pr-50m Click here to resend.


</template>

<script>
  import { resendOneTimePassword } from "@services/vueCustomerSvc";
  import { mapState, mapActions, mapMutations } from 'vuex';
  import MrInput from "@components/mrInput";
  import mask from "../../../directives/mask";
  import { required, minLength } from "@vuelidate/validators";
  import { useVuelidate } from "@vuelidate/core";

  export default {
    name: "SignIn2FA",

    components: {
      MrInput
    },

    directives: {
      mask
    },

    inject: ['getObjProperty'],

    setup () {
      return {
        v$: useVuelidate()
      };
    },

    data() {
      return {
        oneTimePassword: null,
      };
    },

    computed: {
      ...mapState('signIn', [
        'userEmail',
        'verifying'
      ]),

      disableSubmit() {
        return Boolean(this.v$.$invalid || this.verifying);
      },

      sentToEmail() {
        return this.userEmail || 'your email';
      }
    },

    mounted() {
      this.emailCheck();
    },

    methods: {
      ...mapActions([
        'notifySuccess',
        'notifyError',
        'notifyWarn'
      ]),

      ...mapActions('signIn', [
        'signIn',
        'verifyAndSignIn'
      ]),

      ...mapMutations('signIn', [
        'setVerifying',
        'setView'
      ]),

      verifyCode() {
        this.verifyAndSignIn({ oneTimePassword: this.oneTimePassword });
      },

      resendCode() {
        if (this.verifying) {
          return;
        }

        this.emailCheck();
        this.setVerifying(true);

        resendOneTimePassword({ email: this.userEmail }).then(res => {
          this.setVerifying(false);
          if (res.data.status == 0) {
            this.notifySuccess(`New code has been sent to ${this.userEmail}.`);
          } else {
            this.notifyError();
          }
        }).catch(() => {
          this.setVerifying(false);
          this.notifyError();
        });
      },

      emailCheck() {
        if (!this.userEmail) {
          return this.setView('signIn');
        }
      }
    },

    validations: {
      oneTimePassword: {
        required,
        minLength: minLength(6)
      }
    },
  };
</script>

<style scoped lang="stylus">

</style>